import API_END_POINTS from '../../../api/endpoints';
import { dataFetch } from '../../../api/data-fetch';
import PusherOddsConverter from '../../../plugins/PusherOddsConverter';
import { convertBetType } from '../../../utils/convert-bet-type';

const state = () => ({
  eventId: '',
  eventData: {
    events: [],
  },
  betType: 'FixedWin',
  eventOdds: {},
  eventsObj: {},
  isLoadingOdds: false,
});

const actions = {
  updateOdds: ({ commit, state }, data) => {
    const pusherOddsConverter = new PusherOddsConverter();
    const oddsItem = pusherOddsConverter.convert(data.response, state.eventOdds);
    const oddsData = {
      eventId: data.eventId,
      odds: [oddsItem],
    };

    commit('SET_EVENT_ODDS', _oddsDataProcessor(oddsData));
  },

  async fetchEventDataBySlug({ commit }, { slug, eventNumber, betType }) {
    try {
      const meetingEndpoint = `${API_END_POINTS.HARNESS.MEETING}${slug}?include=events`;
      const res = await dataFetch(meetingEndpoint);
      const meetingData = res.data.meeting;
      const eventDataArray = meetingData.events.filter(event => {
        return event.event_number == eventNumber;
      });

      if (eventDataArray.length > 0) {
        // set event data
        const eventObj = eventDataArray[0];

        const includeString = 'entry_conditions,prize_money,results,venue,weather,selections';
        const eventEndpoint = `${API_END_POINTS.HARNESS.EVENTS}/${eventObj.id}?include=${includeString}`;
        const eventRes = await dataFetch(eventEndpoint);
        const event = eventRes.data.event;
        commit('SET_EVENT_ID', event.id);
        // get event odds
        const oddsString = `betTypes=${betType}&priceFluctuations=50&type=best,average,bookmaker`;
        const oddsData = await getEventOdds(event.id, oddsString);

        try {
          if (oddsData && oddsData.hasOwnProperty('odds') && Array.isArray(oddsData.odds)) {
            const oddsDataObj = {
              eventId: event.id,
              odds: oddsData.odds,
            };

            const updatedOddsData = _oddsDataProcessor(oddsDataObj);
            commit('SET_EVENT_ODDS', updatedOddsData);
          }
        } catch (err) {
          console.log(err);
        }

        // get bookmakers
        const bookmakerEndpoint = `${API_END_POINTS.BOOKMAKERS_LIST}&eventId=${event.id}`;
        const { bookmakers, sortOrders } = await dataFetch(bookmakerEndpoint);

        const filtedBookmakers = bookmakers.filter(bookmaker => {
          return sortOrders['punters-win'].some(filter => {
            return filter === bookmaker.id;
          });
        });

        const agencies = filtedBookmakers.sort((a, b) => {
          return sortOrders['punters-win'].indexOf(a.id) - sortOrders['punters-win'].indexOf(b.id);
        });

        // get selections data
        const selections = getSelections(event, oddsData, agencies, sortOrders, betType);

        // update selections in event
        event.selections = selections;
        event.agencies = agencies;
        // set event bet type
        event.isPlace = betType === 'FixedPlace';
        commit('SET_EVENT_DATA', event);
      }
    } catch (error) {
      console.log(error);
    }
  },

  async fetchEventDataById({ commit }, { eventId, betType }) {
    try {
      commit('SET_EVENT_ID', eventId);
      const includeString = 'entry_conditions,prize_money,results,venue,weather,selections';
      const eventEndpoint = `${API_END_POINTS.HARNESS.EVENTS}/${eventId}?include=${includeString}`;
      const res = await dataFetch(eventEndpoint);
      const event = res.data.event;

      // get event odds
      const oddsString = `betTypes=${betType}&priceFluctuations=50&type=best,average,bookmaker`;
      const oddsData = await getEventOdds(eventId, oddsString);

      try {
        if (oddsData && oddsData.hasOwnProperty('odds') && Array.isArray(oddsData.odds)) {
          const oddsDataObj = {
            eventId: eventId,
            odds: oddsData.odds,
          };

          const updatedOddsData = _oddsDataProcessor(oddsDataObj);
          commit('SET_EVENT_ODDS', updatedOddsData);
        }
      } catch (err) {
        console.log(err);
      }

      // get bookmakers
      const bookmakerEndpoint = `${API_END_POINTS.BOOKMAKERS_LIST}&eventId=${eventId}`;
      const { bookmakers, sortOrders } = await dataFetch(bookmakerEndpoint);

      const filtedBookmakers = bookmakers.filter(bookmaker => {
        return sortOrders['punters-win'].some(filter => {
          return filter === bookmaker.id;
        });
      });

      const agencies = filtedBookmakers.sort((a, b) => {
        return sortOrders['punters-win'].indexOf(a.id) - sortOrders['punters-win'].indexOf(b.id);
      });

      // get selections data
      const selections = getSelections(event, oddsData, agencies, sortOrders, betType);

      // update selections in event
      event.selections = selections;
      event.agencies = agencies;
      // set event bet type
      event.isPlace = betType === 'FixedPlace';

      commit('SET_EVENT_DATA', event);
    } catch (error) {
      console.log(error);
    }
  },
  updateBetType({ commit }, betType) {
    commit('UPDATE_BET_TYPE', betType);
  },
};

async function getEventOdds(eventId, paramString) {
  try {
    const oddsEndpoint = `${API_END_POINTS.ODDS.EVENT_BASE}${eventId}?${paramString}`;
    const oddsData = await dataFetch(oddsEndpoint);
    return oddsData;
  } catch (error) {
    console.log(error);
  }
}

function _oddsDataProcessor({ eventId, odds }) {
  if (Array.isArray(odds)) {
    const localOdds = {};
    const localEventOddsKeys = {};

    for (const oddsItem of odds) {
      let oddsLine;
      // Best Odds uses its type to generate odds_line because the bookmaker value will change depending on who has best odds
      if (oddsItem.type === 'best') {
        oddsLine = oddsItem.selectionId + '-' + oddsItem.type + '-' + oddsItem.betType;
      } else {
        oddsLine = oddsItem.selectionId + '-' + oddsItem.bookmakerId + '-' + oddsItem.betType;
      }

      if (!localOdds[oddsLine]) {
        localOdds[oddsLine] = oddsItem;
      }

      // Update this too
      if (Array.isArray(localEventOddsKeys[eventId])) {
        // Check if the oddsLine exists, only add it if it doesn't
        if (!localEventOddsKeys[eventId].includes(oddsLine)) {
          localEventOddsKeys[eventId].push(oddsLine);
        }
      } else {
        localEventOddsKeys[eventId] = [oddsLine];
      }
    }
    return { localOdds, eventId, localEventOddsKeys };
  }
}

// function to filter or order bookmaker prices for a selection
function _pricesProcessor(selection, selectionPrices, eventId, agencies) {
  const prices = agencies.map(agency => {
    let returnObj = {};
    const filteredPrice = selectionPrices.filter(price => {
      return price.bookmakerId === agency.id;
    });

    if (filteredPrice.length > 0) {
      returnObj = {
        betType: filteredPrice[0].betType,
        betUrl: `/link/${filteredPrice[0].bookmakerId}/?eid=${eventId}`,
        bookmaker: filteredPrice[0].bookmakerId,
        bookmakerColors: '',
        bookmakerLower: filteredPrice[0].bookmakerId,
        hasOdds: true,
        isBest: filteredPrice[0].type === 'best',
        odds: filteredPrice[0].price,
        oddsKey: `${selection.id}-${filteredPrice[0].bookmakerId}-${filteredPrice[0].betType}`,
        quickbetEnabled: false,
      };
    } else {
      returnObj = {
        bookmaker: agency.id,
        betUrl: `/link/${agency.id}/?eid=${eventId}`,
        bookmakerColors: '',
        bookmakerLower: agency.id,
        hasOdds: false,
        quickbetEnabled: false,
      };
    }

    return returnObj;
  });
  return prices;
}

// function to get selections avergae odds and return json string of the flucs
function _flucsProcessor(selection, oddsData, betType) {
  // convert to snake-case
  const formatBetType = convertBetType(betType);
  const averageOdds = oddsData.odds.filter(
    odds => odds.betType == formatBetType && odds.type === 'average' && selection.id === odds.selectionId
  );

  // create flucs json string for sparkline to consume
  const flucsArray = [];
  if (averageOdds.length > 0) {
    averageOdds[0].price.fluctuations.map(item => {
      const value = item.value;
      const unixUpdatedAt = parseInt((new Date(item.updatedAt).getTime() / 1000).toFixed(0));
      const flucArray = [unixUpdatedAt, value];
      flucsArray.push(flucArray);
    });
  }

  return JSON.stringify(flucsArray);
}

function getSelections(event, oddsData, agencies, sortOrders, betType) {
  const selections = event.selections.map(selection => {
    // get selection result
    let selectionResult = [];
    const results = event.results;
    if (event.is_resulted && results.length > 0) {
      selectionResult = results.filter(result => {
        return selection.competitor_id === result.competitor_id;
      });
    }
    // get selection prices for included bookmakers
    const selectionPrices = oddsData.odds.filter(
      odds => selection.id === odds.selectionId && sortOrders['punters-win'].includes(odds.bookmakerId)
    );

    // create an array of of price objects
    const prices = _pricesProcessor(selection, selectionPrices, event.id, agencies);

    // get string of selection flucs
    const flucs = _flucsProcessor(selection, oddsData, betType);

    return {
      ...selection,
      prices,
      flucs,
      result: selectionResult.length > 0 ? selectionResult[0].finish_position : '',
    };
  });

  // filter out scratched
  const filteredSelections = selections.filter(item => {
    return !(item.barrier_number === 'Scr' || item.status === 'scratched');
  });

  // order by competitor number
  return filteredSelections.sort((a, b) => {
    return a.competitor_number - b.competitor_number;
  });
}

const mutations = {
  SET_EVENT_ID: (state, eventId) => {
    state.eventId = eventId;
  },
  SET_EVENT_DATA: (state, eventData) => {
    state.eventData.events.push(eventData);
  },
  UPDATE_BET_TYPE: (state, value) => {
    state.betType = value;
  },
  SET_EVENT_ODDS: (state, oddsData) => {
    const { localOdds, eventId, localEventOddsKeys } = oddsData;
    // Update odds
    state.eventOdds = { ...state.eventOdds, ...localOdds };
    // Update event odds keys
    if (!state.eventsObj.hasOwnProperty('eventId')) {
      const updatedEvents = { ...localEventOddsKeys, ...state.eventsObj };
      state.eventsObj = updatedEvents;
    } else {
      state.eventsObj[eventId] = localEventOddsKeys[eventId];
    }
    // data loading process is finished
    state.isLoadingOdds = false;
  },
};

const getters = {
  getData: state => {
    return state.eventData;
  },
  getBetType: state => {
    return state.betType;
  },
  getOdds: state => {
    return state.eventOdds;
  },
  getEvents: state => {
    return state.eventsObj;
  },
  isLoadingOdds: state => {
    return state.isLoadingOdds;
  },
  getEventId: state => {
    return state.eventId;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
